import styles from './styles.module.scss'

import { Card, Button } from 'antd';

import { useState, useEffect, useContext } from 'react';

import { UserContext } from '@/context/user';
import { useHistory } from 'react-router-dom'

import { getNavUrl } from '@/utils/navigation';

interface WithStudyPropertyInput {
  require: string
  passaway?: boolean
  children: JSX.Element
}

export const WithStudyProperty = ({ require, passaway = false, children }: WithStudyPropertyInput) => {
  const history = useHistory()

  const [moveToManage, setMoveToManage] = useState<undefined|boolean>(undefined)

  const hasTempGaId = passaway && window.location.href.includes('tempGaId=')

  const {
    ready,
    ga4Attr,
    uaAttr,
    tagManagerAttr,
    optimizeAttr,
    userId,
  } = useContext(UserContext)

  useEffect(() => {
    if (ready) {
      console.log('require', ready, require, ga4Attr)
      if (require.includes('ga4') && !ga4Attr)  {
        setMoveToManage(true)
      }
    }
  }, [ready, require, ga4Attr, uaAttr, tagManagerAttr, optimizeAttr, userId])

  const goToManage = (e: React.MouseEvent) => {
    history.push(getNavUrl(`/manage?next=/ga4/my&require=${require}`))
  }

  const bodyMinHeightStyle = {
    minHeight: '160px'
  }

  if (hasTempGaId) {
    return (
      <>
        {children}
      </>
    )
  }

  if (moveToManage) {
    return (
      <div className={styles.wrapCard}>
        <Card
          bodyStyle={bodyMinHeightStyle}
          title="실습 설정을 완료해주세요"
          bordered={true}>
          <div>
            <p className={styles.description}>구글 애널리틱스 아이디 설정을 완료해주세요.</p>
          </div>
          <div className={styles.rowActions}>
            <Button type="primary" size="large" onClick={(e) => goToManage(e) }>실습 설정하러 가기</Button>
          </div>
        </Card>
      </div>
    )
  }

  return (
    <>
      {children}
    </>
  )
}